import script from "./ChoiceQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./ChoiceQuestion.vue?vue&type=script&setup=true&lang=js"

import "./ChoiceQuestion.vue?vue&type=style&index=0&id=c0053cb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0053cb6"]])

export default __exports__